module.exports = __webpack_public_path__ + "public/img/staff-life.24b4d60c.png";